import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import {ConfirmationService} from 'primeng/api';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { ClienteComponent } from './cliente/cliente.component';
import { NavegationComponent } from './navegation/navegation.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ProdutoComponent } from './produto/produto.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from './guards/auth.guards';
import { Services } from './services/servicos';
import { RouterModule } from '@angular/router';
import {ROUTES} from './app.routes';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import {ProgressBarModule} from 'primeng/progressbar';
import {MenubarModule} from 'primeng/menubar';
import {MenuModule} from 'primeng/menu';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { SharedModule } from 'primeng/api';
import { HomeComponent } from './home/home.component';
import {ToastModule} from 'primeng/toast';
import {MessageService} from 'primeng/api';
import {CardModule} from 'primeng/card';
import {ToolbarModule} from 'primeng/toolbar';
import {SplitButtonModule} from 'primeng/splitbutton';
import {TableModule} from 'primeng/table';
import {TooltipModule} from 'primeng/tooltip';
import {DialogModule} from 'primeng/dialog';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {InputMaskModule} from 'primeng/inputmask';
import { ServicesProduto } from './produto/servicos-produto';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {InputNumberModule} from 'primeng/inputnumber';
import { registerLocaleData } from '@angular/common';
import localePT from '@angular/common/locales/pt';
import {FileUploadModule} from 'primeng/fileupload';
import {TabViewModule} from 'primeng/tabview';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {DropdownModule} from 'primeng/dropdown';
import { FinanceiroComponent } from './financeiro/financeiro.component';
import { CarteiraComponent } from './carteira/carteira.component';
import { ComercialComponent } from './comercial/comercial.component';
import { TecnicaComponent } from './tecnica/tecnica.component';
import {CalendarModule} from 'primeng/calendar';
import {ChartModule} from 'primeng/chart';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { CentralComponent } from './central/central.component';
import {CarouselModule} from 'primeng/carousel';
import { VistoriaComponent } from './vistoria/vistoria.component';
import { VistoriaManutencaoComponent } from './vistoria-manutencao/vistoria-manutencao.component';
import { GMapModule } from 'primeng/gmap';
import { LocalizacaoTecnicoClienteComponent } from './localizacao/localizacao-tecnico-cliente/localizacao-tecnico-cliente.component';
import { LocalizacaoTecnicoComponent } from './localizacao/localizacao-tecnico/localizacao-tecnico.component';
import { LocalizacaoChamadaComponent } from './localizacao/localizacao-chamada/localizacao-chamada.component';
import { LocalizacaoClienteComponent } from './localizacao/localizacao-cliente/localizacao-cliente.component';
import { FaturamentoComponent } from './faturamento/faturamento.component';

registerLocaleData(localePT, 'pt-BR');

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ClienteComponent,
    NavegationComponent,
    NotFoundComponent,
    ProdutoComponent,
    DashboardComponent,
    HomeComponent,
    FinanceiroComponent,
    CarteiraComponent,
    ComercialComponent,
    TecnicaComponent,
    CentralComponent,
    VistoriaComponent,
    VistoriaManutencaoComponent,
    FaturamentoComponent,
    LocalizacaoChamadaComponent,
    LocalizacaoTecnicoComponent,
    LocalizacaoTecnicoClienteComponent,
    LocalizacaoClienteComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    ProgressBarModule,
    MenubarModule,
    InputTextModule,
    ButtonModule,
    MenuModule,
    BrowserAnimationsModule,
    SharedModule,
    ToastModule,
    CardModule,
    ToolbarModule,
    SplitButtonModule,
    TableModule,
    TooltipModule,
    DialogModule,
    ConfirmDialogModule,
    InputMaskModule,
    InputTextareaModule,
    InputNumberModule,
    FileUploadModule,
    TabViewModule,
    AutoCompleteModule,
    DropdownModule,
    CalendarModule,
    ChartModule,
    ProgressSpinnerModule,
    GMapModule,
    CarouselModule,
    RouterModule.forRoot(ROUTES),
  ],
  providers: [AuthGuard, Services, ServicesProduto, MessageService, ConfirmationService, 
    { provide: LOCALE_ID, useValue: 'pt-BR'}],
  bootstrap: [AppComponent]
})
export class AppModule { }
